import { Alert, Button, Drawer, DrawerBody, DrawerFooter, DrawerHeader, IconButton, Link, LoadingButton, TextField, } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { Close } from '@one-thd/sui-icons';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { useExperienceContext } from '../../../hooks/useContexts';
import { EditDeliveryInstructionsApi } from '../../../api/omm/edit-delivery-instructions';
import { EDIT_DELIVERY_INSTRUCTIONS_ALERT_MESSAGE, instructionsPlaceholder, } from '../../../constants/editDeliveryInstructions';
import '../../../styles/drawer.scss';
import { getWindow } from '../../../utils/general';
import { catchEditDeliveryInstructionsUpdated, catchEditDeliveryInstructionsPostPageLoadError, } from '../../../utils/edit-delivery-instructions/analytics';
import { ProOrderUpForm } from './ProOrderUpForm';
export var EditDeliveryInstructionsDrawer = function (props) {
    var _a;
    var open = props.open, toggleDrawer = props.toggleDrawer, setDrawerError = props.setDrawerError, deliveryInstructionInfo = props.deliveryInstructionInfo;
    var previousDeliveryInstructions = deliveryInstructionInfo.deliveryInstructions;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var _b = useState(false), loading = _b[0], setLoading = _b[1]; // For Loading Button
    var _c = useState(previousDeliveryInstructions), deliveryInstructions = _c[0], setDeliveryInstructions = _c[1];
    var _d = useState(null), alertState = _d[0], setAlertState = _d[1];
    var _e = useState(false), reload = _e[0], setReload = _e[1];
    var _f = useState(false), showSurvery = _f[0], setShowSurvey = _f[1];
    var _g = useThdCustomer(), isLoggedIn = _g.isLoggedIn, isExchangeCustomer = _g.isExchangeCustomer;
    var isAuthTHDUser = isLoggedIn && !isExchangeCustomer;
    var isIos = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.navigator.userAgent.includes('Mac');
    var isIosMobile = isIos && isConsumerApp;
    var deliveryType = deliveryInstructionInfo.deliveryType;
    var isProOrderUpFormEnabled = (FeatureSwitches === null || FeatureSwitches === void 0 ? void 0 : FeatureSwitches.isProOrderUpFormEnabled) &&
        deliveryInstructionInfo.isEditSiteInstructionsEnabled;
    var _h = useState(''), securityCode = _h[0], setSecurityCode = _h[1];
    var _j = useState(''), lockboxLocation = _j[0], setLockboxLocation = _j[1];
    var _k = useState(''), lockboxCode = _k[0], setLockboxCode = _k[1];
    var _l = useState(''), preferredPackagePlacement = _l[0], setPreferredPackagePlacement = _l[1];
    var _m = useState(''), propertyType = _m[0], setPropertyType = _m[1];
    var _o = useState(''), siteConditions = _o[0], setSiteConditions = _o[1];
    var _p = useState(''), additionalInstructions = _p[0], setAdditionalInstructions = _p[1];
    var _q = useState(''), otherPropertyType = _q[0], setOtherPropertyType = _q[1];
    var closeDrawer = function () {
        var _a, _b;
        toggleDrawer();
        setLoading(false);
        if (reload) {
            catchEditDeliveryInstructionsUpdated(deliveryInstructionInfo.fulfillmentType);
            setReload(false);
            (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.reload();
        }
    };
    var renderSurvey = function () { return (React.createElement("div", null,
        React.createElement("input", { type: "hidden", id: "orderNumberForEditDelivery", value: deliveryInstructionInfo.orderId }),
        React.createElement("input", { type: "hidden", id: "orderOriginForEditDelivery", value: deliveryInstructionInfo.orderOrigin }),
        React.createElement("input", { type: "hidden", id: "storeNumberForEditDelivery", value: deliveryInstructionInfo.storeNumber }),
        React.createElement("input", { type: "hidden", id: "salesDateForEditDelivery", value: deliveryInstructionInfo.salesDate }),
        React.createElement("input", { type: "hidden", id: "fulfillmentTypeForEditDelivery", value: deliveryInstructionInfo.surveyFulfillmentType }),
        React.createElement("input", { type: "hidden", id: "customerTypeForEditDelivery", value: deliveryInstructionInfo.customerType }),
        React.createElement("div", { id: "deliveryinstructionsXPsurvey", "data-testid": "deliveryinstructionsXPsurvey", style: {
                display: 'block',
            } }))); };
    var onSubmit = function () {
        setLoading(true);
        var editDeliveryInstructionsRequest = {
            orderId: deliveryInstructionInfo.orderId,
            emailId: deliveryInstructionInfo.emailId,
            et: deliveryInstructionInfo.et,
            newDeliveryInstructions: deliveryInstructions,
            fulfillmentType: deliveryInstructionInfo.fulfillmentType,
            net: deliveryInstructionInfo === null || deliveryInstructionInfo === void 0 ? void 0 : deliveryInstructionInfo.net,
        };
        var traceId = deliveryInstructionInfo === null || deliveryInstructionInfo === void 0 ? void 0 : deliveryInstructionInfo.traceId;
        EditDeliveryInstructionsApi(editDeliveryInstructionsRequest, isAuthTHDUser, deliveryInstructionInfo.xAuthGuestToken, traceId)
            .then(function () {
            setLoading(false);
            setReload(true);
            setAlertState({
                status: 'success',
                alertMessage: EDIT_DELIVERY_INSTRUCTIONS_ALERT_MESSAGE.SUCCESS,
                onClose: closeAlert,
            });
            setShowSurvey(true);
        })
            .catch(function (error) {
            var _a, _b, _c, _d, _e;
            var errorCode = ((_e = (_d = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.code) === null || _e === void 0 ? void 0 : _e.toString()) || 'n/a';
            catchEditDeliveryInstructionsPostPageLoadError(errorCode);
            setLoading(false);
            setDrawerError(deliveryInstructionInfo.fulfillmentGroupIndex);
            closeDrawer();
        });
    };
    var closeAlert = function () {
        setAlertState(null);
    };
    useEffect(function () {
        setAlertState({
            status: 'info',
            alertMessage: EDIT_DELIVERY_INSTRUCTIONS_ALERT_MESSAGE.DEFAULT,
            onClose: closeAlert,
        });
        setDeliveryInstructions(previousDeliveryInstructions);
    }, [open]);
    useEffect(function () {
        if (showSurvery) {
            setTimeout(function () {
                var _a, _b, _c, _d;
                if (((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.QSI) && ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.QSI.API)) {
                    (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.QSI.API.load();
                    (_d = getWindow()) === null || _d === void 0 ? void 0 : _d.QSI.API.run();
                }
            }, 100);
        }
    });
    var handleClearAllButton = function () {
        setDeliveryInstructions('');
        setSecurityCode('');
        setLockboxLocation('');
        setLockboxCode('');
        setPreferredPackagePlacement('');
        setPropertyType('');
        setSiteConditions('');
        setAdditionalInstructions('');
        setOtherPropertyType('');
    };
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-full sui-gap-4 sui-w-96" },
        React.createElement(Drawer, { open: open, onClose: closeDrawer, position: "right" },
            React.createElement(DrawerHeader, { title: "Edit Delivery Instructions", endAdornment: React.createElement(IconButton, { "aria-label": "drawer-close", onClick: closeDrawer, icon: Close }) }),
            React.createElement(DrawerBody, null,
                React.createElement("div", { className: "sui-flex sui-flex-col sui-full sui-gap-4" },
                    alertState && (React.createElement(Alert, { onClose: alertState.onClose, status: alertState.status }, alertState.alertMessage)),
                    showSurvery ? (React.createElement(ErrorBoundary, { name: "edit-pickup-survey" }, renderSurvey())) : (React.createElement("div", { className: "sui-overflow-y-auto responsive-overflow" },
                        React.createElement("div", { className: "sui-text-right sui-pr-5" },
                            React.createElement(Link, { component: "button", onClick: function () {
                                    handleClearAllButton();
                                } }, "Clear All")),
                        isProOrderUpFormEnabled ? (React.createElement(ProOrderUpForm, { securityCode: securityCode, setSecurityCode: setSecurityCode, lockboxLocation: lockboxLocation, setLockboxLocation: setLockboxLocation, lockboxCode: lockboxCode, setLockboxCode: setLockboxCode, preferredPackagePlacement: preferredPackagePlacement, setPreferredPackagePlacement: setPreferredPackagePlacement, propertyType: propertyType, setPropertyType: setPropertyType, siteConditions: siteConditions, setSiteConditions: setSiteConditions, additionalInstructions: additionalInstructions, setAdditionalInstructions: setAdditionalInstructions, otherPropertyType: otherPropertyType, setOtherPropertyType: setOtherPropertyType, deliveryType: deliveryType })) : (React.createElement("div", { className: "sui-pb-5" },
                            React.createElement(TextField, { id: "deliver-instructions-drawer-input", label: "Add Instructions to Driver", placeholder: instructionsPlaceholder, optional: true, value: deliveryInstructions, onChange: function (event) {
                                    if (event.target.value.match(/^.{0,200}$/)) {
                                        setDeliveryInstructions(event.target.value);
                                    }
                                }, fullWidth: true, multiline: true, maxRows: 5 }))))))),
            React.createElement(DrawerFooter, null,
                React.createElement("div", { className: "sui-flex sui-flex-col sui-min-w-full sui-gap-2 sui-mt-8" }, showSurvery ? (React.createElement("div", { className: classNames('card-fix', {
                        'ios-bottom-fix': isIosMobile,
                    }) },
                    React.createElement(Button, { variant: "secondary", onClick: function () {
                            closeDrawer();
                        } }, "Close"))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "card-fix sui-pb-2" },
                        React.createElement(LoadingButton, { onClick: onSubmit, loading: loading }, "Save Changes")),
                    React.createElement("div", { className: classNames('card-fix', {
                            'ios-bottom-fix': isIosMobile,
                        }) },
                        React.createElement(Button, { variant: "secondary", onClick: function () {
                                closeDrawer();
                            } }, "Cancel")))))))));
};
